<template>
  <div
    v-if="author"
    class="blog-author"
  >
    <img
      v-if="author?.Image?.url"
      :src="author.Image.url"
      :alt="author.Image.alternativeText || author.Name"
      :width="author.Image?.width"
      :height="author.Image?.height"
      loading="lazy"
      class="blog-author__image"
    >
    <span
      v-if="author?.Name"
      class="blog-author__name"
    >
      {{ author.Name }}
    </span>

    <AppSocials class="blog-author__socials" />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  author: any
}>()
</script>

<style src="~layers/app/components/Blog/Author.css" />
